import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import {
  getProspectDsr,
  updatePdsr,
  resetDsrPages,
  resetDsrSelectedDisplaySubpage,
  resetDsrTitle,
  updatePdsrReset
} from '../actions/dsr-actions'
import DsrProspectDisplayPage from './DsrProspectDisplayPage'

const ProspectDsrDisplayPageContainer = (props) => {
  return (
    <DsrProspectDisplayPage {...props} />
  )
}

const mapStateToProps = (state) => ({
  retrievedDsrProspect: state.dsrProspect.results.data,
  dsrPagesRedux: state.setDsrPages.pages,
  dsrTitleRedux: state.dsrTitle.title,
  dsrInvalidRequestRedux: state.dsrInvalidRequest.request,
  dsrStatusRedux: state.dsrStatus.status,
  showDsrModalRedux: state.dsrModal.showDsrModal,
  showDsrModalLoaderRedux: state.showDsrModalLoader.show,
  userActionRequiredRedux: state.dsrPopup.UserActionRequired,
  dsrMainContact: state.dsrMainContact.mainContactInfo,
  signout: state.auth.data.signout,
	isProspectorOwner: state.prospectorOwner.isProspectorOwner,
  isShrunkHeader: state.shrunkHeaderView.isShrunkHeader,
  isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProspectDsr,
      resetDsrTitle,
      resetDsrSelectedDisplaySubpage,
      resetDsrPages,
      updatePdsrReset,
      updatePdsr
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProspectDsrDisplayPageContainer))
